module.exports = __webpack_public_path__ + "img/detailsUploadBg.c04df8f7.png";